import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import './LegalPage.css';

export default function ImpressumPage() {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <Link to="/profile" className="legal-back">
          <ChevronLeft size={20} /> Zurück
        </Link>
        <h1 className="legal-title">Impressum</h1>
      </div>

      <div className="legal-content">
        <section className="legal-section">
          <h2>Angaben gemäß § 5 TMG</h2>
          <p>
            LetsCareers<br />
            Musterstraße 1<br />
            67655 Kaiserslautern<br />
            Deutschland
          </p>
        </section>

        <section className="legal-section">
          <h2>Vertreten durch</h2>
          <p>[Vorname Nachname] – Geschäftsführer/in</p>
        </section>

        <section className="legal-section">
          <h2>Kontakt</h2>
          <p>
            Telefon: [Telefonnummer eintragen]<br />
            E-Mail: <a href="mailto:noreply@letscareers.de">noreply@letscareers.de</a>
          </p>
        </section>

        <section className="legal-section">
          <h2>Registereintrag</h2>
          <p>
            Eintragung im Handelsregister.<br />
            Registergericht: Amtsgericht Kaiserslautern<br />
            Registernummer: [Registernummer eintragen]
          </p>
        </section>

        <section className="legal-section">
          <h2>Umsatzsteuer-ID</h2>
          <p>
            Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
            [USt-IdNr. eintragen]
          </p>
        </section>

        <section className="legal-section">
          <h2>Verantwortlich für den Inhalt (§ 55 Abs. 2 RStV)</h2>
          <p>
            [Vorname Nachname]<br />
            Musterstraße 1<br />
            67655 Kaiserslautern
          </p>
        </section>

        <section className="legal-section">
          <h2>Haftungsausschluss</h2>
          <p>
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
            Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten
            nach den allgemeinen Gesetzen verantwortlich.
          </p>
        </section>

        <section className="legal-section">
          <h2>Streitschlichtung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit.
            Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet,
            an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>
      </div>
    </div>
  );
}
